// 引入工具函数
import req from '@/utils/request';

// 获取处方信息
export const getRecipeByOrderId = (params) => {
    return req.get('/order/history/getRecipeByOrderId', params);
}

// 获取划价单挂单详细信息
export const getOrderStaging = (params) => {
    return req.get('/order/payment/new/getOrderStaging', params);
}

// 获取联合订单编号
export const getUniOrderNumber = (params) => {
    return req.post('/order/payment/new/getUniOrderNumber', params);
}

// 获取订单编号
export const getOrderNumber = (params) => {
    return req.post('/order/payment/new/getOrderNumber', params);
}

// 保存编辑划价单挂单
export const editOrderStaging = (params) => {
    return req.post('/order/payment/new/editOrderStaging', params);
}

// 支付
export const pay = (params) => {
    return req.post('/pay/pay', params);
}

// 查询支付信息
export const getPayRecord = (params) => {
    return req.get('/pay/getPayRecord', params);
}

// 付款完成提交订单
export const submitOrderPayment = (params) => {
    return req.post('/order/payment/new/submitOrderPayment', params);
}

// 清楚划价单
export const clearOrderStaging = (params) => {
    return req.get('/order/payment/new/clearOrderStaging', params);
}

// 退款
export const refund = (params) => {
    return req.post('/pay/refund', params);
}

// 查询支付退款记录
export const getOrderRecord = (params) => {
    return req.get('/pay/getOrderRecord', params);
}
// 查询退款记录
export const getRefundRecord = (params) => {
    return req.get('/pay/getRefundRecord', params);
}
// 删除处方
export const removeRecipe = (params) => {
    return req.post('/recipe/removeRecipe', params);
}
//退款提交订单
export const refundOrderPayment = (params) => {
    return req.post('/order/payment/new/refundOrderPayment', params);
}

//保存划价单
export const addOrderPayment = (params) => {
    return req.post('/order/payment/new/addOrderPayment', params);
}
//预支付
export const prePay = (params) => {
    return req.post('/pay/prePay', params);
}
//完成订单
export const completeOrder = (params) => {
    return req.post('/order/completeOrder', params);
}
//是否完成支付
export const isOrderPay = (params) => {
    return req.post('/order/isOrderPay', params);
}

//查询收费项目
export const getChargeItem = (params) => {
    return req.get('/order/payment/charge', params);
}

//保存划价单项目信息
export const saveCharge = (params) => {
    return req.post('/order/payment/saveCharge', params);
}

//删除其他细项、收费细项信息
export const deletePaymentItem = (params) => {
    return req.post('/order/payment/deletePaymentItem', params);
}

//删除划价单项目信息
export const deletePaymentProject = (params) => {
    return req.post('/order/payment/deletePaymentProject', params);
}


//删除草稿就诊信息
export const draftDelete = (params) => {
    return req.post('/order/info/draftDelete', params);
}


//开启、关闭就诊单
export const switchOrderInfo = (params) => {
    return req.post('/order/info/switchOrderInfo', params);
}


//再来一单
export const buyAgain = (params) => {
    return req.post('/order/payment/buyAgain', params);
}

// 转单
export const transferOrder = (params) => {
    return req.post('/ctOrder/transfer', params);
}

// 转单
export const getTransferOrderInfo = (params) => {
    return req.get('/ctOrder/transfer/detail', params);
}

// 查询配方明细
export const getFormulaOrderInfo = (params) => {
    return req.get('/dc/prescription/query', params);
}

// 保存配方明细
export const postFormulaOrderInfo = (params) => {
    return req.post('/dc/prescription/save', params);
}

// 发送验证码
export const sendSmsCode = (params) => {
    return req.post('/wallet/sendSmsCode', params);
}
// 清除验证码
export const clearSmsCode = (params) => {
    return req.post('/wallet/clearSmsCode', params);
}
// 查询订单追溯码
export const queryOrder = (params) => {
    return req.post('/order/queryOrder', params);
}
// 查询配方单追溯码
export const queryHospDrug = (params) => {
    return req.post('/hosp/drug/queryHospDrug', params);
}
